/* unplugin-vue-components disabled */import script from "./IncomePermissionNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncomePermissionNotice.vue?vue&type=script&setup=true&lang=ts"

import "./IncomePermissionNotice.vue?vue&type=style&index=0&id=2de43200&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de43200"]])

export default __exports__